<template>
  <div class="main index">
    <el-row style="margin-top:12px;">
      <el-col :span="12">
        <New4Index v-on:indexWindow="openWin"></New4Index>
      </el-col>
      <el-col :span="12">
        <New4Quantity @indexWindow="openWin"></New4Quantity>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <NewCarMonitor @indexWindow="openWin"></NewCarMonitor>
        <BodyTypeMonthlySale @indexWindow="openWin"></BodyTypeMonthlySale>
      </el-col>
      <el-col :span="12">
        <CurrentMonthlyNewCar @indexWindow="openWin"></CurrentMonthlyNewCar>
        <GainCharts @indexWindow="openWin"></GainCharts>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12"></el-col>
      <el-col :span="12"></el-col>
    </el-row>

    <el-row>
      <el-col :span="12"></el-col>
      <el-col :span="12"></el-col>
    </el-row>


     <el-dialog
     :visible.sync="showDialog"
     :before-close="hideDialog"
     :center="true"
     :show-close="true"
     :append-to-body="true"
     >
          <el-table :data="gridData">
    <el-table-column property="date" label="日期" width="150"></el-table-column>
    <el-table-column property="name" label="姓名" width="200"></el-table-column>
    <el-table-column property="address" label="地址"></el-table-column>
  </el-table>

     </el-dialog>
  </div>
</template>
 
<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import New4Quantity from "@/components/charts/New4Quantity.vue";
import Permissions from "@/store/permissions.js";
import ProvinceChart from "@/components/charts/ProvinceChart.vue";
import New4Index from "@/components/charts/New4Index2.vue";
import NewCarMonitor from "@/components/charts/NewCarMonitor.vue";
import BodyTypeMonthlySale from "@/components/charts/BodyTypeMonthlySale.vue";
import CurrentMonthlyNewCar from "@/components/charts/CurrentMonthlyNewCar.vue";
import GainCharts from "@/components/charts/GainCharts.vue";
export default {
  name: "home",
  components: {
    New4Quantity,
    ProvinceChart,
    New4Index,
    NewCarMonitor,
    BodyTypeMonthlySale,
    CurrentMonthlyNewCar,
    GainCharts
  },
  data() {
    return {

      showDialog:false,
      gridData:[]
    };
  },
  methods: {
   
     openWin(msg){
       
        this.showDialog = true;
        console.log(msg);
         
     },
     hideDialog(){
       this.showDialog = false;
     }

  },
  computed: {
    ...mapState({
      isLoading: state => state.indexLoadingCount > 0
    })
  },
  mounted() {
    //   alert(Permissions['Pages.Users']);
  }
};
</script>

